import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
  withFetch,
  withJsonpSupport,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { provideStore, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { fspApiHeadersInterceptor } from './app.interceptors';
import { reducer } from './features/landing-page/src/lib/store/reducers/discovery-flights.reducer';
import { DiscoveryFlightsEffects } from './features/landing-page/src/lib/store/effects/discovery-flights.effects';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([errorInterceptor, fspApiHeadersInterceptor]),
      withFetch(),
      withJsonpSupport(),
    ),
    provideAnimations(),
    provideStore(),
    provideState({ name: 'discoveryFlights', reducer }),
    provideEffects([DiscoveryFlightsEffects]),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
    }),
    importProvidersFrom(RecaptchaV3Module),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: () => environment.recaptchaSiteKey,
    },
  ],
};
